module.exports = __webpack_public_path__ + "img/logo.541ce588.png";